import { Text, VisuallyHidden } from '@ui'

// Starred walks (2026-10-14): a walk marked to find again quickly. The star is the walk's, not the
// recording's: the server marks every recording overlapping a starred one.

function StarShape({ filled }) {
  return (
    <svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true">
      <path
        d="M8 1.3l2 4.3 4.7.5-3.5 3.2 1 4.6L8 11.5l-4.2 2.4 1-4.6L1.3 6.1 6 5.6z"
        fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"
      />
    </svg>
  )
}

// The marker in the calendar (and anywhere a star is only shown, not changed).
export function StarIcon(style) {
  return (
    <Text className="star-marker" title="Starred" {...style}>
      <StarShape filled />
      <VisuallyHidden>Starred</VisuallyHidden>
    </Text>
  )
}

// A star that turns on or off. In the walks table it sits inside a clickable row, so the click
// stops there. `quiet`: an unstarred star only shows on row hover or focus (the table's rows).
export function StarToggle({ starred, onChange, busy = false, quiet = false, large = false }) {
  const label = starred ? 'Starred: click to unstar' : 'Star this walk'
  return (
    <button
      type="button"
      className={['star-toggle', starred && 'is-starred', quiet && 'is-quiet', large && 'is-large'].filter(Boolean).join(' ')}
      aria-pressed={starred}
      aria-label={label}
      title={label}
      disabled={busy}
      onClick={(e) => { e.stopPropagation(); onChange(!starred) }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <StarShape filled={starred} />
    </button>
  )
}

// A walk's time span as the server's star queries take it: end time, else start plus moving time,
// capped at 12 h.
function span(w) {
  const start = Date.parse(w.start_time)
  const end = w.end_time ? Date.parse(w.end_time) : start + (w.moving_duration_ms ?? 0)
  return [start, Math.min(end, start + 12 * 3600 * 1000)]
}

// Whether two recordings are of the same real walk (overlapping in time), as the server decides it.
export function sameWalk(a, b) {
  if (a.id === b.id) return true
  const [as, ae] = span(a)
  const [bs, be] = span(b)
  return bs < ae && be > as
}

// The walks list with a star change applied ahead of the server's reply: on starring, every
// recording overlapping `walk`; on unstarring, every recording overlapping it loses its star.
export function withStar(walks, walk, starred) {
  return walks.map((w) => (sameWalk(walk, w) ? { ...w, starred } : w))
}
